var React = require('react');

function Mt (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#eee","d":"M0 0h256l52 259.2L256 512H0z","key":0}),React.createElement("path",{"fill":"#d80027","d":"M256 0h256v512H256z","key":1}),React.createElement("path",{"fill":"#acabb1","d":"M178 100.2V66.8h-33.3v33.4h-33.4v33.4h33.4V167h33.4v-33.4h33.4v-33.4z","key":2})])]);
}

Mt.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Mt;

Mt.default = Mt;
